import Index from "./pages";
import AnalyticsPage from "./pages/analytics";
import AppAssetsPage from "./pages/app-assets";
import AppSettingsPage from "./pages/app-settings";
import AttributesPage from "./pages/attributes";
import BrandsPage from "./pages/brands";
import CategoriesPage from "./pages/categories";
import ColorsPage from "./pages/colors";
import DashboardPage from "./pages/dashboard";
import NotFoundView from './pages/errors/NotFoundView'
import FAQ from "./pages/FAQ";
import FiltersPage from "./pages/filters";
import GlancePage from "./pages/glance";
import HeatmapPage from "./pages/heatmap";
import LanguagePage from "./pages/language";
import LoginPage from "./pages/login";
import ModelsPage from "./pages/models";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ProductsPage from "./pages/products";
import ProfilePage from "./pages/profile";
import ReviewsPage from "./pages/reviews";
import ReveiwParameters from "./pages/reviews/review-parameters";
import SeoSettingsPage from "./pages/seo-settings";
import TermsAndConditions from "./pages/TermsAndConditions";
import UsersPage from "./pages/users";

const PublicRoutes = [
    
    {
        path: "/auth",
        name: "login",
        component: LoginPage
    },
    
    
]

const PrivateRoutes = [
    // {
    //     path: '/',
    //     name: 'home',
    //     component: Index
    // },
    {
        path: '/glance',
        name: 'glance',
        component: GlancePage
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: DashboardPage
    },
    {
        path: "/profile",
        name: "ProfilePage",
        component: ProfilePage
    },
    {
        path: "/heatmap",
        name: "Heatmap",
        component: HeatmapPage
    },
    {
        path: "/language",
        name: "Languages",
        component: LanguagePage
    },
    {
        path: "/users",
        name: "Users",
        component: UsersPage
    },
    {
        path: "/products",
        name: "Products",
        component: ProductsPage
    },
    {
        path: "/categories",
        name: "Categories",
        component: CategoriesPage
    },
    {
        path: "/attributes",
        name: "Attributes",
        component: AttributesPage
    },
    {
        path: "/review-and-ratings",
        name: "Ratings & Reviews",
        component: ReviewsPage
    },
    {
        path: "/review-parameters",
        name: "Review Parameters",
        component: ReveiwParameters
    },
    {
        path: "/seo-settings",
        name: "Seo Settings",
        component: SeoSettingsPage
    },
    {
        path: "/app-settings",
        name: "App Settings",
        component: AppSettingsPage
    },
    {
        path: "/app-assets",
        name: "App Assets",
        component: AppAssetsPage
    },
    {
        path: "/filters",
        name: "Filters",
        component: FiltersPage
    },
    {
        path: "/colors",
        name: "Colors",
        component: ColorsPage
    },
    {
        path: "/brands",
        name: "Brands",
        component: BrandsPage
    },
    {
        path: "/models",
        name: "Models",
        component: ModelsPage
    },
    {
        path: "/faq",
        name: "FAQ",
        component: FAQ
    },
    {
        path: "/terms-and-conditions",
        name: "Terms & Conditions",
        component: TermsAndConditions
    },
    {
        path: "/privacy-policy",
        name: "Privacy Policy",
        component: PrivacyPolicy
    },
    {
        path: '*',
        name: 'Page Not Found',
        component: NotFoundView
    }
]

export { 
    PublicRoutes,
    PrivateRoutes
 };